import {useEffect} from 'react';
import { Link } from 'react-router-dom';
import TextField from '../components/Form/TextField';
import MetaData from '../layouts/MetaData';
import { useDispatch, useSelector } from 'react-redux';
import { useAlert } from 'react-alert';
import { Formik, Form } from 'formik';
import { Image } from 'react-bootstrap';
import * as Yup from 'yup';
import { resetpassword } from '../actions/authActions';
import TDW_logo from '../assets/Images/vitals_portal_logo.png';
import { PoweredBy } from '../components/common/Branding';
import loginIllustration from '../assets/Images/loginRPM.svg';


const ResetPassword = (props) => {
	
	// function useQuery() {
	// 	return new URLSearchParams(useLocation().search);
	//   }
	  
    // let query = useQuery();
    const queryToken = props?.match?.params?.token;
  
    const alert = useAlert();
	const dispatch = useDispatch();
    const {error, message} = useSelector(state => state.common);

    useEffect(() => {
        if(message){
            alert.success(message)
        }

        if(error){
            alert.error(error)
        }
    }, [message, error])


    const validate = Yup.object().shape({
		password: Yup.string()
        .min(8, 'Should be atleast 8 characters')
        .max(20, 'Should be less than 20 characters')
        .required('Password is Required'),
	  });

    const submitHandler = (values) => {
        const { password, confirm_password} = values;
        if(password === confirm_password){
            dispatch(resetpassword(values, queryToken));
        } else {
            alert.error('Passwords not matched');
            return
        }
    }

  return (
    <>
		<MetaData title="Reset Password" />
		 <>
				<div className="login-section">
					<img src={loginIllustration} className="login-illustration" alt="Remote patient monitoring illustration" />
					<div className="container">
						<div className="row content">
						<Image src={TDW_logo} style={{height:"80px"}} alt="Vitals Portal"/>
							<PoweredBy className="w-100 mt-1" />		
								
							<div className="col-md-12"  >
							<hr/>
							<div>
								<h3 className='title'>Reset Password.</h3>
								<h5 style={{color: '#999'}}>Please enter your new password.</h5>
							</div>
							
								<Formik initialValues={{
									password: '',
								}}
								validationSchema={validate}
								onSubmit={values => {
									submitHandler(values)
								}}
								>
										<div>
											<Form>
												<TextField 
													label="New Password" 
													name="password" 
													type="password" 
													placeholder="Enter new password"
												/>

                                                <TextField 
													label="Confirm Password" 
													name="confirm_password" 
													type="password" 
													placeholder="Confirm password"
												/>
												
												<br/><br/>
												

												<div className="row-class" style={{justifyContent: 'space-between'}}>
													<button className="submit-btn ml-3" type="submit">Save</button>
												</div>
											</Form>

											<br/><br/><br/>
												<div className="row-display" style={{justifyContent: 'flex-end'}}>
													<Link to="/login" style={{textDecoration: 'none'}}><small>Go to Login</small></Link>
												</div>
										</div>
								</Formik>											
							</div>
						</div>
					</div>
				</div>
		</>
        
    </>
  )
}

export default ResetPassword